import * as sagas from './sagas';

export const acceptPageInvitationModel = { sagas };
